var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{ref:"mainArea"},[_c('transition',{attrs:{"name":_vm.animationName,"mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"TransactionsModule"}},[(_vm.isAllLoaded)?_c('router-view'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }